module.exports = "https://static-production.npmjs.com/da3ab40fb0861d15c83854c29f5f2962.png";